import { camelCase, forEach, set, transform } from 'lodash';
import {
  ApplicationConfigFieldGroup,
  ApplicationConfigStep,
  ProposalPermission,
  ProposalPermissions,
  ProposalPermissionStatus,
} from '@lockton-apps/shared/interfaces';

export function buildPermissions(
  steps: ApplicationConfigStep[] | undefined = []
): ProposalPermissions {
  return transform(
    steps,
    (permissions: ProposalPermissions, step: ApplicationConfigStep) => {
      forEach(step.fieldGroups, (section: ApplicationConfigFieldGroup) => {
        forEach(
          section.permissions,
          (permission: ProposalPermission, type: string) => {
            set(permissions, `${type}.${camelCase(step.id)}.${section.id}`, {
              ...permission,
              status: ProposalPermissionStatus.Enabled,
            });
          }
        );
      });
    },
    {} as ProposalPermissions
  );
}
